t = require('views/internal/teacup-with-helpers')('boards_sidebar')

module.exports = t.renderable ->
  t.p '.quiet.u-text-align-center.hide', { style: 'margin: 6px 4px 0 0; padding: 8px 12px;' }, ->
    t.format 'no-boards'

  t.div '.starred-sidebar-boards-list.js-starred-boards'

  t.div '.js-recent-boards'

  t.div '.js-all-boards'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/boards_sidebar_boards.coffee